/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IInternalCrosstabHeaderCell } from '../types/CrosstabVisualizationTypes';
import { ILevelsLayout } from '../../../../store/types/StateTypes';
import { getOutputParamsKeyFromField } from '../../chart/util/EventUtil';

interface IOptions {
    levelsStructure :ILevelsLayout,
    type: string
    nodes :(IInternalCrosstabHeaderCell | null)[],
    depth? :number
}

const getHyperlinkDataFromNodes = (options: IOptions) => {

    const {
        levelsStructure,
        type,
        nodes,
        depth
    } = options;

    const linkData :any = {};

    let maxIndex = nodes.length - 1;
    if (typeof depth !== 'undefined') {
        maxIndex = Math.min(depth, maxIndex);
    }

    for (let index = 0; index <= maxIndex; index += 1) {

        const node = nodes[index];

        if (!node || node.loading) {
            // eslint-disable-next-line no-continue
            continue;
        }

        let key,
            value;

        if (node.isMeasure) {

            let measureName = node.label;
            if (node.isTotal) {
                measureName = 'total_node';
            }

            key = 'Measures';
            value = [measureName];

        } else {

            let level;
            if (type === 'column') {
                level = levelsStructure.columns[index];
            } else {
                level = levelsStructure.rows[index];
            }
            key = getOutputParamsKeyFromField(level);

            value = node.label;
            if (node.isTotal) {
                value = 'total_node';
            }
        }

        if (key) {
            linkData[key] = value;
        }
    }

    return linkData;
};

export default {
    getHyperlinkDataFromNodes
}
